import moment from "moment";


export const timeFromNow = (time: number): string => {
  return moment(time * 1000).fromNow()
}